import { LoadingSkeleton } from 'core/components/common/LoadingSkeleton';
import { JianDetail as JianDetailComponent } from 'core/components/JianDetail';
import { Suspense } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/** 事案詳細全体のコンポーネント。 */
export const JianDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const selectedDate = params.get('selected-date');
  const searchQuery = params.get('search');
  const page = params.get('page');

  // 事案一覧に戻る際のパラメータを構築
  const handleBackToList = () => {
    const queryParams = new URLSearchParams();
    if (selectedDate) queryParams.set('selected-date', selectedDate);
    if (searchQuery) queryParams.set('search', searchQuery);
    if (page) queryParams.set('page', page);

    const queryString = queryParams.toString();

    navigate(`/jian-list${queryString ? `?${queryString}` : ''}`);
  };

  return (
    <div className="container mx-auto px-4">
      <button
        className="flex items-center text-primary hover:text-primary-dark transition-colors duration-200"
        onClick={handleBackToList}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-5 h-5 mr-2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
        <span className="text-base font-medium">事案の一覧に戻る</span>
      </button>
      <div className="mt-6">
        <Suspense fallback={<LoadingSkeleton />}>
          <JianDetailComponent />
        </Suspense>
      </div>
    </div>
  );
};
